import { statusTone } from '../lib/status-labels';

export const MODERATION_PILL_TONE = {
  info: 'bg-info/15 text-info',
  pending: 'bg-primary/15 text-primary',
  success: 'bg-status-success/15 text-status-success',
  danger: 'bg-delivery-red-tint text-delivery-red',
  neutral: 'bg-status-neutral/15 text-status-neutral',
  active: 'bg-status-neutral/15 text-status-neutral',
} as const;

export const MODERATION_PILL_BASE =
  'inline-flex items-center justify-center rounded-full px-3 py-0.5 text-sm leading-5 font-normal whitespace-nowrap';

interface ModerationStatusPillProps {
  status: string | null | undefined;
  label: string;
}

/**
 * Status pill (Figma badge frame 616:17716): solid soft tint, no border, no
 * leading dot — the kit's `StatusBadge` always renders a dot, so the pill is
 * composed directly from design tokens. Compact size: 14px regular text on a
 * 20px line height with 2px vertical padding for an exact 24px height, fully
 * rounded. `danger` uses the exact Figma swatches
 * (Red/100 `#fee2e2` wash, Red/600 `#dc2626` text) via the delivery tokens,
 * which resolve to those hexes in light mode and lift them for legibility in
 * dark mode. `pending` uses brand orange (the Figma "На проверке" badge is
 * orange, not the kit's amber pending tone).
 *
 * Lives on the entity (not the table widget) because the queue table and the
 * review modal both render it.
 */
export function ModerationStatusPill({ status, label }: ModerationStatusPillProps) {
  return (
    <span
      data-status={(status ?? '').toLowerCase()}
      className={`${MODERATION_PILL_BASE} ${MODERATION_PILL_TONE[statusTone(status)]}`}
    >
      {label}
    </span>
  );
}
